import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material'
import { SupportAgent, ArrowBack } from '@mui/icons-material'
import React, { useContext } from 'react'
import Context from '../../contexts/Context'
import UserMenu from '../../components/Shared/UserMenu'

const HeaderTicket = () => {
  const { user } = useContext(Context)

  const handleBackToApp = () => {
    window.close()
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: '#FFFFFF',
        borderBottom: '1px solid #E2E8F0',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', maxWidth: 1200, width: '100%', mx: 'auto', px: { xs: 2, sm: 3, md: 4 } }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              bgcolor: '#F1F5F9',
              px: 1.5,
              py: 0.5,
              borderRadius: 2,
            }}
          >
            <SupportAgent sx={{ color: '#475569', fontSize: 22 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1E293B', letterSpacing: '-0.01em' }}>
              Central de Suporte
            </Typography>
          </Box>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          {user && (
            <Typography variant="body2" sx={{ color: '#64748B', display: { xs: 'none', sm: 'block' } }}>
              {user.first_name} {user.last_name}
            </Typography>
          )}
          <UserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default HeaderTicket
